import React from 'react'
import Sidebar from '../components/common/Sidebar';
import Navbar from '../components/common/Navbar';
import { Outlet } from 'react-router-dom';

function SupplementLayout() {
  return (
    <div className="flex gap-2">
      <Sidebar />
      <div className="w-full flex-1">
        <Navbar />
        <main className="px-4 pt-8 overflow-y-auto scrollbar-hide h-[calc(100vh-6rem)]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default SupplementLayout;